module.exports = __webpack_public_path__ + "static/harta-prestari-servicii-administrare-imobile.ffe86c89.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/harta-prestari-servicii-administrare-imobile.svg
// module id = 461
// module chunks = 35783957827783